import React from 'react'
import _get from 'lodash/get'
import { TopicBodyContainer } from './styles'
import {
  DetailsSubTopicHeading,
  LawCitation,
  MarkdownWrap,
} from '../TopicsDetailComponent/styles'
import Markdown from '../../../../../common/components/markdown'
import { StyledExternalLink } from '../../../../../theme/Global'
import { formatLink } from '../../../../../common/helpers'


const WrappedMarkdown = ({ content }) => (
  <MarkdownWrap>
    <Markdown>
      {content}
    </Markdown>
  </MarkdownWrap>
)

const ContentComponent = ({ Component, content }) => ((content)
  ? <Component>{content}</Component>
  : null)


const showSubtopicHeader = (topic, subTopic) => {
  const clean = (string) => string.toLowerCase().trim()
  if (!topic || !subTopic) return false
  if (typeof topic !== 'string' || typeof subTopic !== 'string') return false
  if (clean(subTopic) !== clean(topic)) return true
  return false
}

// renders a topic with subTopics
const TopicBody = ({ topic }) => (
  <TopicBodyContainer data-testid="topic-body" key={`TopicBody_${topic.id}`}>
    {topic.subTopics.map((subTopic, idx) => (
      <React.Fragment key={`subTopicId:${subTopic.id},idx:${idx}`}>
        {(showSubtopicHeader(topic.topic, subTopic.subTopic))
          ? (
            <ContentComponent
              {...{
                Component: DetailsSubTopicHeading,
                content: subTopic.subTopic
              }}
            />
          )
          : null }
        <WrappedMarkdown {...{ content: subTopic.context }} />
        <ContentComponent {...{
          Component: LawCitation,
          content: subTopic.lawCitation
        }}
        />
        <ContentComponent {...{
          Component: LawCitation,
          content: subTopic.regulationCitation
        }}
        />
        {_get(subTopic, 'links', []).map((link) => (
          <div key={`link_${link}_${subTopic.subTopic}`}>
            <StyledExternalLink href={link}>
              {formatLink(link)}
            </StyledExternalLink>
          </div>
        ))}
      </React.Fragment>
    ))}

  </TopicBodyContainer>
)

export default TopicBody
